import React, { useEffect, useState } from "react";

import mbxStatic from "@mapbox/mapbox-sdk/services/static";

import { Image } from "components/ui/source";

interface StaticMapProps {
  center: {
    lng: number;
    lat: number;
  };
  className: string;
}

export const StaticMap = ({ center, className }: StaticMapProps) => {
  const [staticClient, setStaticClient] = useState(null);
  const [mapUrl, setMapUrl] = useState<string>("");

  useEffect(() => {
    setStaticClient(mbxStatic({
      accessToken: global.MAPBOX_TOKEN,
    }));
  }, [])

  useEffect(() => {
    if (!staticClient) {
      return;
    }

    if (!mapUrl) {
      const request = staticClient.getStaticImage({
        ownerId: "mapbox",
        styleId: "streets-v12",
        width: 1040,
        height: 416,
        logo: false,
        position: {
          coordinates: [center.lng, center.lat],
          zoom: 13.5,
        },
        overlays: [
          {
            marker: {
              size: "large",
              coordinates: [center.lng, center.lat],
              color: "#FF2400",
            },
          },
        ],
      });
      setMapUrl(request.url());
    }
  }, [center.lat, center.lng, mapUrl, staticClient]);

  if (!staticClient) return null;

  return (
    <div className={className}>
      {mapUrl && <Image width="100%" src={mapUrl} alt={"map"} />}
    </div>
  );
};
